// extracted by mini-css-extract-plugin
export default {"listContainer":"ValuesList_listContainer__tYV7N","listItem":"ValuesList_listItem__zdZCG","item":"ValuesList_item__BFWwQ","valueContainer":"ValuesList_valueContainer__x73tJ"};